import { render, staticRenderFns } from "./SetVideoToBeInstructionsDialog.vue?vue&type=template&id=7e23e160&scoped=true"
import script from "./SetVideoToBeInstructionsDialog.vue?vue&type=script&lang=js"
export * from "./SetVideoToBeInstructionsDialog.vue?vue&type=script&lang=js"
import style0 from "./SetVideoToBeInstructionsDialog.vue?vue&type=style&index=0&id=7e23e160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e23e160",
  null
  
)

export default component.exports